import { render, staticRenderFns } from "./addUserInfo.vue?vue&type=template&id=1185199d&"
import script from "./addUserInfo.vue?vue&type=script&lang=js&"
export * from "./addUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports